import axiosInstance from '../auth/axiosConfig';
import {
  CATEGORIA_REQUEST,
  CATEGORIA_SUCCESS,
  CATEGORIA_FAIL,
} from './types';
import { Dispatch } from 'redux';


export const categoriaActions = (anioSeleccionado: number, establ_corr: number) => async (dispatch: Dispatch): Promise<boolean> => {

  dispatch({ type: CATEGORIA_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/categoriaActions?anioSeleccionado=${anioSeleccionado}&establ_corr=${establ_corr}`);

    if (res.status === 200) {
      if (res.data) {
        dispatch({
          type: CATEGORIA_SUCCESS,
          payload: res.data
        });
        return true;
      }

    } else {
      dispatch({ type: CATEGORIA_FAIL });
    }
    return false;
  } catch (err: any) {
    dispatch({
      type: CATEGORIA_FAIL,
      error: "Error en la solicitud:", err,
    });
    return false;
  }
};
